import axios from "axios";
import React, {Component} from "react";
import ReactToPrint from "react-to-print";
import FeatherIcon from 'feather-icons-react';
import Headerpdf from "../../users/Headerpdf";
import UserIdentity from "../../users/UserIdentity";
import { Link } from "react-router-dom";

class Profilefile extends Component{

    state = {
        student : { user : { user : {} }, father : {}, monther : {}, reportcards: [] },
        reportcard : true,
        schoolfee : true,
        studentschoolfees : { schoolfees: [] },
        labels : [],
        months : [],
        loading: true,
        error: "",
        reportcardError: "",
        schoolfeeError: "",
    }

    componentDidMount(){
        this.getUser();
    }

    handleInput = ({ target: { name } }) => {
        this.setState((state) => ({ [name]: !state[name] }));
    }

    handleInputR = this.handleInput;

    getUser = async () => {
        this.setState({ loading: true, error: "" });
        try {
            const response = await axios.get("students/" + this.props.match.params.studentId);
            const student = response.data || { user: { user: {} }, reportcards: [] };
            this.setState({ student });
            await Promise.all([
                this.getReportcards(student),
                this.getStudentschoolfees(),
                this.getMonth(),
            ]);
            this.setState({ loading: false });
        } catch (error) {
            this.setState({
                loading: false,
                error: error.response?.data?.msg || "Impossible de charger la fiche de cet élève.",
            });
        }
    }

    getMonth = async () => {
        try {
            const response = await axios.get("months");
            this.setState({ months: Array.isArray(response.data) ? response.data : [] });
        } catch (error) {
            this.setState({ months: [] });
        }
    }

    getReportcards = async (student) => {
        try {
            const response = await axios.get('/student/reportcards/' + this.props.match.params.studentId);
            const results = new Map();

            (response.data?.reportcards || []).forEach((evaluation) => {
                const lesson = evaluation.sectionclasselesson?.lesson;
                if (!lesson?.id) return;

                const totals = (evaluation.notes || []).reduce((sum, note) => ({
                    note: sum.note + Number(note.note || 0),
                    max: sum.max + Number(note.evaluation?.max || 0),
                }), { note: 0, max: 0 });
                const staff = evaluation.sectionclasselesson?.staff?.user;
                const current = results.get(lesson.id) || {
                    id: lesson.id,
                    lesson: lesson.entitled_lesson || lesson.short_entitled_lesson,
                    staff: "",
                    note: 0,
                    max: 0,
                };

                results.set(lesson.id, {
                    ...current,
                    note: current.note + totals.note,
                    max: current.max + totals.max,
                    staff: staff ? [staff.last_name, staff.first_name].filter(Boolean).join(" ") : current.staff,
                });
            });

            (student.reportcards || [])
                .filter((reportcard) => Number(reportcard.periode?.id) === 1)
                .forEach((reportcard) => {
                    const lesson = reportcard.sectionclasselesson?.lesson;
                    if (!lesson?.id || results.has(lesson.id)) return;
                    const staff = reportcard.sectionclasselesson?.staff?.user;
                    results.set(lesson.id, {
                        id: lesson.id,
                        lesson: lesson.entitled_lesson || lesson.short_entitled_lesson,
                        staff: staff ? [staff.last_name, staff.first_name].filter(Boolean).join(" ") : "",
                        note: 0,
                        max: 0,
                    });
                });

            this.setState({ labels: Array.from(results.values()), reportcardError: "" });
        } catch (error) {
            this.setState({ labels: [], reportcardError: "Impossible de charger le parcours scolaire." });
        }
    }

    getStudentschoolfees = async () => {
        try {
            const response = await axios.get('/students/schoolfees/' + this.props.match.params.studentId);
            this.setState({
                studentschoolfees: response.data || { schoolfees: [] },
                schoolfeeError: "",
            });
        } catch (error) {
            this.setState({
                studentschoolfees: { schoolfees: [] },
                schoolfeeError: "Impossible de charger les paiements scolaires.",
            });
        }
    }

    getProfile = () => {
        try {
            return JSON.parse(localStorage.getItem('profile') || '{}');
        } catch (error) {
            return {};
        }
    }


    render(){
        const { student, loading, error } = this.state;

        if (loading) return <main className="container ev-page student-file-page">
            <div className="student-profile-state" role="status"><span className="spinner-border spinner-border-sm" />Chargement de la fiche…</div>
        </main>;
        if (error) return <main className="container ev-page student-file-page">
            <div className="student-profile-state is-error"><FeatherIcon icon="alert-circle" size={18} /><strong>{error}</strong><button className="btn btn-sm btn-outline-primary" onClick={this.getUser}>Réessayer</button></div>
        </main>;

        const profile = this.getProfile();
        const establishment = profile?.profile?.establishment || {};
        const user = student.user || {};
        const tutor = user.user || {};
        const last_name = user.last_name || "—";
        const first_name = user.first_name || "—";
        const family_name = user.family_name || "—";
        const classe = student.sectionclass ? [student.sectionclass.class?.short_entitled_class, student.sectionclass.title].filter(Boolean).join(" ") : "—";
        const section = student.sectionclass?.section?.entitled_section || "—";
        const overallRate = Number(student.studentmax) > 0 ? ((Number(student.studentsuccess || 0) * 100) / Number(student.studentmax)).toFixed(1) : "—";
        const schoolfees = this.state.studentschoolfees?.schoolfees || [];
        const months = this.state.months.length ? this.state.months : Array.from(new Map(
            schoolfees.filter((fee) => fee.month?.id).map((fee) => [fee.month.id, fee.month])
        ).values());
        return(
            
        <main className="container ev-page student-file-page">
                <header className="ev-page-header student-profile-header student-file-header"><div className="ev-page-header__content"><span className="ev-page-header__eyebrow"><FeatherIcon icon="folder" size="14" /> Ressources humaines</span><h1>Fiche complète de l'élève</h1><p>Identité, parcours scolaire et paiements réunis dans un dossier imprimable.</p></div>
                <div className="ev-page-header__actions">
                    <Link to={"/students/" + this.props.match.params.studentId} className="btn btn-sm btn-light student-profile-action"><FeatherIcon icon="arrow-left" size="15" /> Retour au profil</Link>
                    <ReactToPrint
                        trigger={() => <button className="btn btn-sm btn-primary student-profile-action" type="button"><FeatherIcon icon="printer" size="15" /> Imprimer la fiche</button>}
                        content={() =>  this.componentRef}
                    />
                </div></header>
            <div className="row student-file-sheet" ref={el => (this.componentRef = el)}>
                  <Headerpdf />
                    {
                       <UserIdentity  title={`Fiche de l'élève ${ last_name } ${ family_name } ${ first_name } ${ classe } ${ section } ${ student && (student.year ? student.year.year : "")}`}/> 
                    }
                <div className="col-md-12">
                    <div className="card student-file-card">
                        <div className="card-body row student-file-body">
                            <div className="col-lg-4 student-file-person ev-no-print">
                                <div className="student-file-title"><FeatherIcon icon="user" size="15" /> Identité de l'élève</div>
                                <div className="d-flex">
                                    <div className="image mr-3">
                                        <img src={ student && ( student.user.avatar)} className="img-fluid" width={ student && ( student.user.avatar && ("100"))} /> 
                                    </div>
                                    <div className="mt-0 ms-2">
                                        <div  className=" font-monospace">
                                            <div><span className="fw-bolder">Nom : </span> {last_name }</div>
                                            <div><span className="fw-bolder">Prénom : </span> { first_name }</div>
                                            <div><span className="fw-bolder">Post-nom : </span> { family_name}</div>
                                            <div><span className="fw-bolder">Matricule : </span> { student && ( student.matricule)}</div>
                                            <div><span className="fw-bolder">Identité : </span> { student && ( student.user.identity_number)}</div>
                                            <div><span className="fw-bolder">Contact : </span> { student && ( student.user.tel)},  { student && ( student.user.email)}</div>
                                            <div><span className="fw-bolder">adress : </span> { student && ( student.user.adress)}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 student-file-person ev-no-print">
                                <div className="student-file-title"><FeatherIcon icon="user-check" size="15" /> Identité du père</div>
                                <div className="d-flex">
                                    <div className="image mr-3">
                                        <img src={ student.father && ( student.father.avatar)} className="img-fluid" width={ student.father && ( student.father.avatar && ("100"))} /> 
                                    </div>
                                    
                                    <div className="mt-0 ms-2">
                                        <div  className="font-monospace">
                                            <div><span className="fw-bolder">Nom : </span> { student.father && (  student.father.last_name)} </div>
                                            <div><span className="fw-bolder">Prénom : </span> { student.father && (  student.father.first_name)} </div>
                                            <div><span className="fw-bolder">Identité : </span> { student.father && ( student.father.identity_number)}</div>
                                            <div><span className="fw-bolder">Contact : </span> { student.father && ( student.father.tel)},  { student.father && ( student.father.email)}</div>
                                            <div><span className="fw-bolder">adress : </span> { student.father && ( student.father.adress)}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 student-file-person ev-no-print">
                                <div className="student-file-title"><FeatherIcon icon="heart" size="15" /> Identité de la mère</div>
                                <div className="d-flex">
                                    <div className="image mr-3">
                                        <img src={ student.monther && ( student.monther.avatar)} className="img-fluid" width={ student.monther && ( student.monther.avatar && ("100"))} /> 
                                    </div>
                                    <div className="mt-0 ms-2">
                                        <div  className="font-monospace">
                                            <div><span className="fw-bolder">Nom : </span> { student.monther && (  student.monther.last_name)} </div>
                                            <div><span className="fw-bolder">Prénom : </span> { student.monther && (  student.monther.first_name)} </div>
                                            <div><span className="fw-bolder">Identité : </span> { student.monther && ( student.monther.identity_number)}</div>
                                            <div><span className="fw-bolder">Contact : </span> { student.monther && ( student.monther.tel)},  { student.monther && ( student.monther.email)}</div>
                                            <div><span className="fw-bolder">adress : </span> { student.monther && ( student.monther.adress)}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-12 row student-file-context ev-no-print">
                                <div className="student-file-section-title"><span><FeatherIcon icon="briefcase" size="16" /> Établissement et tuteur</span></div>
                                <div className="col-lg-4 student-file-person">
                                    <div className="d-flex">
                                        <div className="mt-0 ms-2">
                                            <div  className=" font-monospace">
                                                <div><span className="fw-bolder">Classe : </span> { classe} </div>
                                                <div><span className="fw-bolder">Section : </span> { section } </div>
                                                <div><span className="fw-bolder">Année : </span> { student && ( student.year ?  student.year.year : "")} </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 student-file-person">
                                    <div className="d-flex">
                                        <div className="image mr-3">
                                            {establishment.logo ? <img src={establishment.logo} className="img-fluid" alt={`Logo de ${establishment.name || "l'établissement"}`} /> : <FeatherIcon icon="home" size={22} />}
                                        </div>
                                        <div className="mt-0 ms-2">
                                            <div  className=" font-monospace">
                                                <div><span className="fw-bolder">Etablissement : </span> {establishment.name || "—"} </div>
                                                <div><span className="fw-bolder">Type : </span> {establishment.type || "—"}</div>
                                                <div><span className="fw-bolder">Contact : </span> {[establishment.email, establishment.tel].filter(Boolean).join(", ") || "—"}</div>
                                                <div><span className="fw-bolder">Adresse : </span> {[establishment.region, establishment.municipality, establishment.city, establishment.other_adress].filter(Boolean).join(", ") || "—"}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="col-lg-4 student-file-person">
                                    <div className="d-flex">
                                        <div className="image mr-3">
                                            {tutor.avatar ? <img src={tutor.avatar} className="img-fluid" alt="Portrait du tuteur" /> : <FeatherIcon icon="user" size={22} />}
                                        </div>
                                        <div className="mt-0 ms-2">
                                            <div  className="font-monospace">
                                                <div><span className="fw-bolder">Nom : </span> {tutor.last_name || "—"} </div>
                                                <div><span className="fw-bolder">Prénom : </span> {tutor.first_name || "—"} </div>
                                                <div><span className="fw-bolder">Identité : </span> {tutor.identity_number || "—"}</div>
                                                <div><span className="fw-bolder">Contact : </span> {[tutor.tel, tutor.email].filter(Boolean).join(", ") || "—"}</div>
                                                <div><span className="fw-bolder">Adresse : </span> {tutor.adress || "—"}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div className="col-md-12 student-file-data">
                                <div className="student-file-toggle table_action">
                                    <input type="checkbox" name="reportcard" checked={this.state.reportcard} id="reportcard" onChange={this.handleInputR} /> <label htmlFor="reportcard">Afficher le parcours scolaire</label>
                                 </div>
                                <div className={this.state.reportcard ? "student-file-section-title" : "d-none"}><span><FeatherIcon icon="book-open" size="16" /> Parcours scolaire</span></div>
                                 <div className={this.state.reportcard ? "table-responsive student-file-table" : "d-none" }>
                                    {this.state.reportcardError && <div className="student-file-empty is-error">{this.state.reportcardError}</div>}
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th>N°</th>
                                                <th>Cours</th>
                                                <th>Note</th>
                                                <th>Max</th>
                                                <th>Pourcent</th>
                                                <th>Titulaire</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                [...this.state.labels].sort((a, b) => b.max - a.max).map((label, index) =>{
                                                    return(
                                                        <tr key={label.id || index}>
                                                            <td>{ index+1 }</td>
                                                            <td>{ label.lesson || "—" }</td>
                                                            <td align="right" className={ label.max > 0 && label.note < (label.max /2) ? "text-danger" : ""}>{ label.max > 0 ? label.note : "—" }</td>
                                                            <td align="right">{ label.max > 0 ? label.max : "—" }</td>
                                                            <td align="right">{ label.max > 0 ? ((label.note * 100) / label.max).toFixed(1) + "%" : "—" }</td>
                                                            <td align="right">{ label.staff || "—" }</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                            <tr>
                                                <th colSpan={4}>
                                                    Total
                                                </th>
                                                <td align="right" className="fw-bolder">
                                                    {overallRate}{overallRate === "—" ? "" : "%"}
                                                </td>
                                                <td>
                                                    {student.id && <button className="student-file-report table_action" type="button" onClick={() => window.open(process.env.REACT_APP_EVIVESOMA_STAT + "/students/" + student.id,"Rating","width=950,height=500,left=200,top=200,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,location=no,directories=no,status=no")}>Voir le bulletin</button>}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                 </div>
                            </div>

                            <div className="col-md-12 student-file-data">
                                 <div className="student-file-toggle table_action">
                                    <input type="checkbox" name="schoolfee" checked={this.state.schoolfee} id="schoolfee" onChange={this.handleInput} /> <label htmlFor="schoolfee">Afficher les paiements scolaires</label>
                                 </div>
                                <div className={this.state.schoolfee ? "student-file-section-title" : "d-none"}><span><FeatherIcon icon="credit-card" size="16" /> Paiements scolaires</span></div>
                                 <div className={this.state.schoolfee ? "table-responsive student-file-table" : "d-none" }>
                                    {this.state.schoolfeeError && <div className="student-file-empty is-error">{this.state.schoolfeeError}</div>}
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th>Mois</th>
                                                <th>Montant</th>
                                                <th>Paiement</th>
                                                <th>N° facture</th>
                                                <th>Année</th>
                                                <th>Date</th>
                                                <th>Responsable</th>
                                                <th>Comptable</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {months.map((month) => {
                                                const monthFees = schoolfees.filter((fee) => fee.month?.id === month.id);
                                                if (monthFees.length === 0) return <tr key={month.id}>
                                                    <td align="center" className="fw-bolder">{month.month}</td>
                                                    <td colSpan={7} className="student-file-table-empty">Aucun paiement</td>
                                                </tr>;

                                                return monthFees.map((schoolfee, index) => <tr key={schoolfee.id}>
                                                    {index === 0 && <td align="center" className="fw-bolder" rowSpan={monthFees.length}>{month.month}</td>}
                                                    <td align="right">{Number(schoolfee.pay_mount || 0).toLocaleString("fr-FR")} {schoolfee.sectionschoolfeecategory?.currency || ""}</td>
                                                    <td>{schoolfee.sectionschoolfeecategory?.schoolfeecategory?.category || "—"}, { schoolfee.trimesectschool?.trimester?.short_trimester || ''}</td>
                                                    <td align="right">{schoolfee.invoice || "—"}</td>
                                                    <td>{schoolfee.year?.year || "—"}</td>
                                                    <td align="right">{schoolfee.createdAt ? new Date(schoolfee.createdAt).toLocaleDateString("fr-FR") : "—"}</td>
                                                    <td align="right">{[schoolfee.user?.last_name, schoolfee.user?.first_name].filter(Boolean).join(" ") || "—"}</td>
                                                    <td align="right">{[schoolfee.staff?.user?.last_name, schoolfee.staff?.user?.first_name].filter(Boolean).join(" ") || "—"}</td>
                                                </tr>);
                                            })}
                                            {months.length === 0 && <tr><td colSpan={8} className="student-file-table-empty">Aucun paiement enregistré.</td></tr>}
                                        </tbody>
                                    </table>
                                 </div>
                            </div>
                             
                        </div>
                    </div>
 
                    
                </div>
                
            </div>

        </main>
        )
    }
}
export default  Profilefile
